import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted, computed} from 'vue';
import MultiformApi from '@/modules/multiForm/services/MultiformApi';
import {useInstance} from '@/composables/useInstance';


export default /*#__PURE__*/_defineComponent({
  __name: 'FpNipForm',
  props: {
    value: null,
    partnerWithoutNip: { type: Boolean }
  },
  emits: ["input", "fetchCompanyDataByNip", "update:nip"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: string | null): void;
  (event: 'fetchCompanyDataByNip', response: any, nip: string | null): void;
  (event: 'update:nip', value: string | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: string | null;
  partnerWithoutNip?: boolean;
}

const {$i18n, $env, $errorHandler,} = useInstance();




const nip = ref<string | null>(null);

const appDomainConfig = $env?.getAppDomainConfig();

const model = computed({
  get: () => props.value,
  set: (value) => {
    nip.value = value;
    emit('input', value);
  },
});

const validated = computed(() => {
  const validator = appDomainConfig.taxIdentificationNumber.validator;
  if (validator?.length) {
    return nip.value ? nip.value.toString().length === validator.length : false;
  } else if (validator?.validationFunc) return validator.validationFunc(nip.value as string);
  else return true;
});

onMounted(() => {
  if (props.value && props.value.length !== 0) {
    nip.value = props.value;
  }
  fetchCompanyDataByNip();
});

const fetchCompanyDataByNip = async() => {
  if (validated.value) {
    try {
      emit('update:nip', nip.value);
      if (appDomainConfig.taxIdentificationNumber.hasCompanyDataApiIntegration) {
        const response = await MultiformApi.getCompanyDataByNip(nip.value!);
        if (response) {
          emit('fetchCompanyDataByNip', response, nip.value);
        }
      }
    } catch (e) {
      $errorHandler(e, $i18n.useFpNipForm.FETCH_NIP_DATA_ERROR_HANDLER);
    }
  }
};

return { __sfc: true,$i18n, $env, $errorHandler, props, emit, nip, appDomainConfig, model, validated, fetchCompanyDataByNip }
}

})